import config from 'config';
import type { User } from 'types/user';
import type { UsersDraft } from 'types/users';

export function generateUserDraft(
  attributes: Partial<UsersDraft> = {},
  dependencies: {
    defaultRoleId: number;
    workspaceWeeklyCapacity: number;
    defaultWeekdays: string;
  }
): UsersDraft {
  const defaults: UsersDraft = {
    name: '',
    email: '',
    role_id: dependencies.defaultRoleId,
    can_create_projects: false,
    hide_hourly_rate: false,
    hide_internal_hourly_rate: true,
    default_hour_rate: config.defaultHourRate,
    internal_hour_rate: config.defaultInternalHourRate,
    initial_default_hour_rate: attributes.default_hour_rate ?? config.defaultHourRate,
    apply_default_rate: null,
    admin: false,
    avatar: {
      large_retina: '',
      medium_retina: '',
    },
    teams: undefined,
    deleted: false,
    weekly_capacity: dependencies.workspaceWeeklyCapacity,
    add_to_all_projects: false,
    projects: { spec: 'patch', add: [], update: [], remove: [] },
    active_projects_count: attributes.active_projects_count ?? 0,
    addedProjectsByClient: {},
    work_days: attributes.work_days ?? dependencies.defaultWeekdays,
    update_existing_hours: true,
    update_unbilled_only: true,
  };

  return {
    ...defaults,
    ...attributes,
  };
}

export function convertUserToDraft(user: User): UsersDraft {
  return {
    initial_default_hour_rate: user.default_hour_rate,
    apply_default_rate: null,
    addedProjectsByClient: {},
    projects: { spec: 'patch', add: [], update: [], remove: [] },
    ...user,
    active_projects_count: user.active_projects_count ?? 0,
    userAccountProperties: {},
  };
}
